import React, { useEffect } from 'react';

const InvitePage = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');
    
    if (token) {
      window.location.href = `/?token=${token}`;
    } else {
      window.location.href = '/';
    }
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <p>Redirecting...</p>
    </div>
  );
};

export default InvitePage;